<template>
  <v-container>
    <template v-if="!loading">
      <v-row>
        <v-col cols="12" lg="4" offset-lg="4">
          <v-form class="form">
            <v-text-field
              :label="emailLabel"
              :value="userEmail"
              color="secondary"
              disabled
              required
            ></v-text-field>
            <template v-if="formEditable">
              <v-text-field
                :append-icon="oldPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
                :label="oldPasswordLabel"
                :type="oldPasswordShow ? 'text' : 'password'"
                v-model="oldPassword"
                :disabled="!formEditable"
                color="secondary"
                v-validate.disable="'required|min:9'"
                :error-messages="errors.collect(oldPasswordLabel)"
                :data-vv-name="oldPasswordLabel"
                @click:append="oldPasswordShow = !oldPasswordShow"
                required
              ></v-text-field>
              <v-text-field
                :append-icon="newPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
                :label="newPasswordLabel"
                v-model="newPassword"
                :type="newPasswordShow ? 'text' : 'password'"
                :disabled="!formEditable"
                color="secondary"
                v-validate.disable="'required|min:9'"
                :error-messages="errors.collect(newPasswordLabel)"
                :data-vv-name="newPasswordLabel"
                @click:append="newPasswordShow = !newPasswordShow"
                required
              ></v-text-field>
              <v-text-field
                :append-icon="repeatNewPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
                :label="repeatNewPasswordLabel"
                v-model="repeatNewPassword"
                :type="repeatNewPasswordShow ? 'text' : 'password'"
                :disabled="!formEditable"
                color="secondary"
                v-validate.disable="'required|min:9'"
                :error-messages="errors.collect(repeatNewPasswordLabel)"
                :data-vv-name="repeatNewPasswordLabel"
                @click:append="repeatNewPasswordShow = !repeatNewPasswordShow"
                required
              ></v-text-field>
            </template>
            <v-btn
              large
              @click="edit"
              block
              :outlined="!formEditable"
              color="primary"
              class="mt-3"
            >
              <v-icon left>{{
                formEditable ? "mdi-lock-open" : "mdi-lock"
              }}</v-icon>
              {{
                formEditable
                  ? $t("message.common.save")
                  : $t("message.common.resetPassword")
              }}</v-btn
            >
          </v-form>
        </v-col>
        <SectionLoader :status="loading" :opacity="1" />
      </v-row>
    </template>
  </v-container>
</template>

<script>
import SectionLoader from "@/components/Loader/SectionLoader.vue";

import ErrorHandler from "@/helpers/handlers/error";
import usersService from "@/services/users";

export default {
  name: "UserSettingsUserProfile",
  components: {
    SectionLoader
  },
  data() {
    return {
      loading: false,
      valid: false,
      formEditable: false,
      oldPasswordShow: false,
      newPasswordShow: false,
      repeatNewPasswordShow: false,
      newPassword: "",
      oldPassword: "",
      repeatNewPassword: "",
      repeatNewPasswordLabel: this.$t("message.common.repeatNewPassword"),
      newPasswordLabel: this.$t("message.common.newPassword"),
      oldPasswordLabel: this.$t("message.common.oldPassword"),
      emailLabel: this.$t("message.common.email")
    };
  },
  computed: {
    userEmail() {
      return this.$store.state.auth.user.email;
    }
  },
  methods: {
    edit() {
      if (this.formEditable) {
        this.$validator.validate().then(valid => {
          valid ? this.submit() : null;
        });
      }

      this.formEditable = true;
    },

    async submit() {
      try {
        await usersService.changePassword({
          old_password: this.oldPassword,
          new_password1: this.newPassword,
          new_password2: this.repeatNewPassword
        });

        this.$notify({
          group: "default",
          type: "success",
          text: this.$t("message.notification.userLoggedInSuccess")
        });

        this.clearForm();

        this.formEditable = false;
      } catch (error) {
        ErrorHandler.displayError(error);
      }
    },

    clearForm() {
      this.oldPassword = "";
      this.newPassword = "";
      this.repeatNewPassword = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  margin-top: 125px;
}
</style>
